import React, { useMemo } from 'react'
import { addMore, secondsToHms, truncate } from '../../../../shared/helpers'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import tts from '../../lib/TTS'
import type { ContentMetadataProps } from './types'

const VIDEO_DETAIL_METADATA_FOCUS_KEY = 'VIDEO_DETAIL_METADATA'

function ContentMetadata(props: ContentMetadataProps) {
  const { ref, focused, isHovered } = useHybridFocusable({
    focusKey: VIDEO_DETAIL_METADATA_FOCUS_KEY,
    onFocus: () => {
      tts.stopRead()
      tts.addTextToRead([
        truncate.apply(description_long, [100, true]),
        'press enter to hear the full description',
      ])
    },
    onEnterPress: () => {
      if (isFocused) {
        props.handleDescriptionModal?.()
      }
    },
  })

  const isFocused = useMemo(() => focused || isHovered, [focused, isHovered])

  const {
    showTitle,
    episodeTitle,
    content_rating,
    captionTracks,
    duration,
    description_long,
    formattedOrdinals,
  } = props.videoDetails

  return (
    <div className="video-detail-screen__metadata">
      <h2 className="video-detail-screen__show-title">{showTitle}</h2>
      <h3 className="video-detail-screen__video-title">
        {truncate.apply(episodeTitle, [56])}
      </h3>

      <div className="video-detail-screen__details-line">
        <span className="video-detail-screen__detail-line-section">
          {formattedOrdinals}
        </span>

        {duration && duration > 0 ? (
          <>
            <span className="video-detail-screen__divider">|</span>
            <span className="video-detail-screen__detail-line-section">
              {secondsToHms(duration)}
            </span>
          </>
        ) : null}

        {content_rating ? (
          <>
            <span className="video-detail-screen__divider">|</span>
            <span className="video-detail-screen__detail-line-section">
              {content_rating}
            </span>
          </>
        ) : null}

        {captionTracks && captionTracks[0] ? (
          <>
            <span className="video-detail-screen__divider">|</span>
            <span className="video-detail-screen__closed-captions">cc</span>
          </>
        ) : null}
      </div>

      <div
        ref={ref}
        className={`video-detail-screen__description ${
          isFocused ? 'active' : 'inactive'
        }`}
      >
        <span>{truncate.apply(description_long, [100, true])}</span>
        <span
          className={`video-detail-screen__more-text ${
            isFocused ? 'active' : 'inactive'
          }`}
        >
          {addMore.apply(description_long, [100])}
        </span>
      </div>
    </div>
  )
}

export default ContentMetadata
